import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import LocationPicker from './LocationPicker';
var LocationPickerModal = function (_a) {
    var isOpen = _a.isOpen, toggle = _a.toggle, point = _a.point, onSave = _a.onSave;
    var _b = React.useState(point), localPoint = _b[0], setLocalPoint = _b[1];
    React.useEffect(function () {
        setLocalPoint(point);
    }, [point]);
    var handleChange = function (updatedPoint) {
        setLocalPoint(updatedPoint);
    };
    var handleSave = function () {
        onSave(localPoint);
        toggle();
    };
    return (React.createElement(Modal, { isOpen: isOpen, toggle: toggle, size: "lg" },
        React.createElement(ModalHeader, { toggle: toggle }, "Editar punto de ubicaci\u00F3n"),
        React.createElement(ModalBody, null,
            React.createElement(LocationPicker, { initialValue: localPoint, onChange: handleChange })),
        React.createElement(ModalFooter, null,
            React.createElement(Button, { color: "secondary", onClick: toggle }, "Cancelar"),
            React.createElement(Button, { color: "primary", onClick: handleSave }, "Guardar"))));
};
export default LocationPickerModal;



//////////////////
// WEBPACK FOOTER
// ./src/components/LocationPicker/AdvancedLocationPicker/LocationPickerModal.tsx
// module id = 1536
// module chunks = 0